// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/App/Static/Page/index.scss
// module id = 8280
// module chunks = 2